module.exports = __webpack_public_path__ + "img/no-record2.30c1233a.png";